import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-white scroll-mt-[72px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择8848影院
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-xl mx-auto">
            更纯净的追剧环境，更全面的内容覆盖，给你最舒适的看剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="group flex flex-col items-center text-center p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 hover:scale-[1.03] cursor-default"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}